import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Link,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import TicketIcon from "../icons/TicketIcon";
import UserLevelChip from "../level/UserLevelChip";

// Map TicketTransactionTypes enum to readable strings
const getTransactionTypeString = (transactionType) => {
  const typeMap = {
    0: "Adjustment",
    1: "Stage Winnings",
    2: "Prize Draw",
    3: "Swap For Tickets",
    4: "Refund",
    5: "Store Purchase"
  };

  return typeMap[transactionType] || `Type ${transactionType}`;
};

export default function TicketTransactionsTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Player Value</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Reference</TableCell>
            <TableCell>Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.transactions?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.transactionId}
              </TableCell>
              <TableCell component="th" scope="row">
                <Link
                  href={`/dashboard/profile?user_id=${row.userId}`}
                  sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}
                >
                  {row.userId}
                </Link>
              </TableCell>
              <TableCell component="th" scope="row">
                <UserLevelChip level={row.userLevelStats?.topPct} />
              </TableCell>
              <TableCell component="th" scope="row">
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <TicketIcon size={20} />
                  {row.amount}
                </div>
              </TableCell>
              <TableCell component="th" scope="row">
                {getTransactionTypeString(row.transactionType)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.reference}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(new Date(row?.createdAt * 1000))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
